const MediaQueryManager = function (config) {
    const mediaQueries = {};

    for (const key in config) {
        if (Object.hasOwnProperty.call(config, key)) {
            mediaQueries[key] = window.matchMedia(config[key]);
        }

    }

    // Safari <= 13 needs eventtarget.polyfill.js
    const target = new EventTarget();

    for (const key in mediaQueries) {
        if (Object.hasOwnProperty.call(mediaQueries, key)) {
            const fn = e => {
                if (e.matches) {
                    target.dispatchEvent(new CustomEvent('change', { detail: key }));
                }
            };
            const mq = mediaQueries[key];
            if (typeof mq.addEventListener === 'function') {
                mq.addEventListener('change', fn);
            } else {
                // Safari has no addEventListener
                mq.addListener(fn);
            }
        }
    }

    const init = function () {
        for (const key in mediaQueries) {
            if (Object.hasOwnProperty.call(mediaQueries, key)) {
                if (mediaQueries[key].matches) {
                    target.dispatchEvent(new CustomEvent('init', { detail: key }));
                }
            }
        }
    }

    return {
        onInit: function (callback) {
            target.addEventListener('init', callback);
            init();
        },
        onChange: function (callback) {
            target.addEventListener('change', callback);
        },
    };
}
